import {
  Alert,
  AlertTitle,
  Autocomplete,
  Box,
  Button,
  Container,
  Divider,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  Modal,
  Paper,
  Radio,
  RadioGroup,
  Skeleton,
  Snackbar,
  Table,
  TableBody,
  TableCell,
  tableCellClasses,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import styled from "@emotion/styled";
import { DatePicker } from "@mui/x-date-pickers";
import { Fragment, useEffect, useRef, useState } from "react";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { DateRangePicker } from "react-date-range";
import { enUS } from "date-fns/locale";
import { format, isValid, set } from "date-fns";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  downloadCSVFile,
  downloadExcelFile,
  downloadInvoiceFileUpdated,
  getActiveReportEnabledCustomers,
  getCurrency,
  getCustomerByID,
  getCustomerStaticDataByCustID,
  getLoggedInUser,
  getTpBatchReport,
} from "../redux/actions/AdminAction";
import {
  GET_CUSTOMER_RESET,
  GET_CUSTOMER_STATIC_DATA_RESET,
  DOWNLOAD_INVOICE_RESET,
  GET_TP_BATCH_REPORT_RESET,
} from "../Constants/Constants";
import { LoadingButton } from "@mui/lab";
import CircularProgressWithLabel from "../Components/CircularProgressWithLabel";
import CircularProgress from '@mui/material/CircularProgress';
import useMediaQuery from "@mui/material/useMediaQuery";
import LiveHelpIcon from "@mui/icons-material/LiveHelp";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";

const StyledTableCell = styled(TableCell)(() => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#282828",
    color: "#ffffff",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(() => ({
  "&:nth-of-type(odd)": {
    backgroundColor: "#e8e9eb",
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#f5f5f9",
    color: "rgba(0, 0, 0, 0.87)",
    maxWidth: 400,
    fontSize: theme.typography.pxToRem(10),
    border: "1px solid #dadde9",
  },
}));

const formatFormOfPaymentLabel = (value) =>
  value === "Credit" ? "Credit Card" : value;

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 300,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 5,
  textAlign: "center",
};

function createData(
  ticket_number,
  ticket_status,
  name,
  date,
  fare,
  taxes,
  pnr,
  currency,
  fop
) {
  return {
    ticket_number,
    ticket_status,
    name,
    date,
    fare,
    taxes,
    pnr,
    currency,
    fop,
  };
}

const isVoidTicket = (ticketStatus) =>
  String(ticketStatus || "").trim().toUpperCase() === "VOID"|| String(ticketStatus || "").trim().toUpperCase() === "REFUND";

const getTicketStatus = (ticket = {}) =>
  ticket?.ticket_status || ticket?.transaction || "";

const getEticketCount = (ticket = {}) => Number(ticket?.eticket_count) || 0;

const PRIVILEGED_REPORT_USERNAME = "admin";
const PRIVILEGED_REPORT_PASSWORD = "Travelport@2026";

export default function PrivilegedNewTicketReport(props) {
  const { decodedToken } = props;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isLargeScreen = useMediaQuery("(max-width:1869px)");
  const isMediumScreen = useMediaQuery("(max-width:1800px)"); // For tablet responsiveness
  const isSmallScreen = useMediaQuery("(max-width:1500px)");
  const token = JSON.parse(localStorage.getItem("userInfo"));
  const loggedInUserId = JSON.parse(localStorage.getItem("user_id"));
  const loggedInUserEmail = localStorage.getItem("user_email") || "";
  const ticketStatusFilter = ["ALL", "VENTE", "VOID", "REFUND"];
  const formOfPaymentFilter = [
    "ALL",
    "CASH",
    "CHECK",
    "Credit",
    "MiscFormOfPayment",
  ];
  const today = new Date();
  const todayAtMidnight = new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate()
  );
  const minSelectableDate = new Date(2023, 0, 1);
  const maxSelectableDate = new Date(todayAtMidnight);
  if (maxSelectableDate < minSelectableDate) {
    maxSelectableDate.setTime(minSelectableDate.getTime());
  }
  const initialDate =
    maxSelectableDate >= minSelectableDate ? maxSelectableDate : minSelectableDate;

  const [row, setRow] = useState(null);
  const [snackOpen, setSnackOpen] = useState(false);
  const [errorAlert, setErrorAlert] = useState(false);
  const [errorAlertTitle, setErrorAlertTitle] = useState("");
  const [errorAlertMessage, setErrorAlertMessage] = useState("");
  const [infoAlert, setInfoAlert] = useState(false);
  const [infoAlertMessage, setInfoAlertMessage] = useState("");
  const [selected_pcc, setSelected_pcc] = useState(null);
  const [PCCs, setPCCs] = useState([]);
  const [date_range, setDate_range] = useState({
    startDate: initialDate,
    endDate: initialDate,
    key: "selection",
  });
  const [totalFares, setTotalFares] = useState(null);
  const [totalTaxes, setTotalTaxes] = useState(null);
  const [totalAmount, setTotalAmount] = useState(null);
  const [totalComm, setTotalComm] = useState(null);
  const [currencies, setCurrencies] = useState({ default: "Default" });
  const [currency, setCurrency] = useState("default");
  const [response_currency, setRespose_currency] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [progress, setProgress] = useState(0);
  const [apiResponseTime, setApiResponseTime] = useState(0);
  const [reportGenerated, setReportGenerated] = useState(false);
  const [ticketReportInfo, setTicketReportInfo] = useState(null);
  const [selectedTicketStatusFilter, setSelectTicketStatusFilter] =
    useState("ALL");
  const [selectedFormOfPaymentFilter, setSelectFormOfPaymentFilter] =
    useState("ALL");
  const [customer_id, setCustomer_id] = useState(null);
  const [customer_name, setCustomer_name] = useState(null);
  const [xlsxLoading, setXlsxLoading] = useState(false);
  const [xlsLoading, setXlsLoading] = useState(false);
  const [reportType, setReportType] = useState("g");
  const [iata_number, setIata_number] = useState(null);
  const [query_date_time, setQuery_date_time] = useState(null);
  const [totalIssuedTicket, setTotalIssuedTicket] = useState(null);
  const [totalRefundTicket, setTotalRefundTicket] = useState(null);
  const [customerCountry, setCustomerCountry] = useState(null);
  const [openReportTypeReminder, setOpenReportTypeReminder] = useState(false);
  const [pendingReportType, setPendingReportType] = useState(null);
  const [isPrivilegedAuthenticated, setIsPrivilegedAuthenticated] =
    useState(false);
  const [privilegedUsername, setPrivilegedUsername] = useState("");
  const [privilegedPassword, setPrivilegedPassword] = useState("");
  const [privilegedAuthError, setPrivilegedAuthError] = useState("");
  const tableRef = useRef(null);
  const invoiceFileUrlRef = useRef(null);

  const GetAllActiveReportEnabledCustomers = useSelector(
    (state) => state.GetAllActiveReportEnabledCustomers
  );
  const { activeReportEnabledCustomersInfo } =
    GetAllActiveReportEnabledCustomers;
  // const hasActiveReportEnabledCustomers =
  //   (Array.isArray(activeReportEnabledCustomersInfo) &&
  //     activeReportEnabledCustomersInfo.length > 0) ||
  //   (!Array.isArray(activeReportEnabledCustomersInfo) &&
  //     Object.keys(activeReportEnabledCustomersInfo || {}).length > 0);

  const GetCustomerByID = useSelector((state) => state.GetCustomerByID);
  const { customerById } = GetCustomerByID;
  const reportLanguage =
    customerById?.report_language?.trim() ||
    customerById?.[0]?.report_language?.trim() ||
    "";

  const GetTpBatchReportData = useSelector((state) => state.GetTpBatchReportData);
  const { tpBatchReportData, loading } = GetTpBatchReportData;

  const GetCurrency = useSelector((state) => state.GetCurrency);
  const { currencyInfo } = GetCurrency;

  const DownloadExcelFile = useSelector((state) => state.DownloadExcelFile);
  const { downloadExcelLoading } = DownloadExcelFile;

  const DownloadCSVFile = useSelector((state) => state.DownloadCSVFile);
  const { downloadCSVLoading } = DownloadCSVFile;
  // const [xlsxLoading, setXlsxLoading] = useState(false);
  const {
    invoiceData,
    invoiceLoading,
    invoiceError,
  } = useSelector((state) => state.InvoiceDisplay);

  const [openInvoiceModel, setOpenInvoiceModel] = useState(false);
  const [openMultiTicketInvoiceDialog, setOpenMultiTicketInvoiceDialog] =
    useState(false);
  const [pendingInvoiceRequest, setPendingInvoiceRequest] = useState(null);
  const [addServiceFee, setAddServiceFee] = useState("no");
  const [serviceFeeAmount, setServiceFeeAmount] = useState("");
  const [serviceFeeOption, setServiceFeeOption] = useState("");

  useEffect(() => {
    if (invoiceData) {
      setLoadingRowId(null);
      setOpenInvoiceModel(true);
    }
  }, [invoiceData]);

  useEffect(() => {
    invoiceFileUrlRef.current = invoiceData?.fileUrl || null;
  }, [invoiceData]);
  const [loadingRowId, setLoadingRowId] = useState(null);
  const GetCustomerStaticDataByCustID = useSelector(
    (state) => state.GetCustomerStaticDataByCustID
  );
  const { customerStaticDataInfo } = GetCustomerStaticDataByCustID;

  const GetLoggedInUser = useSelector((state) => state.GetLoggedInUser);
  const { loggedInUserInfo } = GetLoggedInUser;

  useEffect(() => {
    if (customer_id && Array.isArray(tpBatchReportData)) {
      setTicketReportInfo(tpBatchReportData);
      return;
    }

    setTicketReportInfo(null);
  }, [customer_id, tpBatchReportData]);

  useEffect(() => {
    setReportType("g");
    dispatch(getCustomerStaticDataByCustID(customer_id));
  }, [customer_id]);

  useEffect(() => {
    if (
      reportGenerated &&
      (!tpBatchReportData || Object.keys(tpBatchReportData).length === 0)
    ) {
      setInfoAlertMessage(
        "Oops! No data available for the selected date range or currency. Please try adjusting your dates or currency and search again."
      );
      setSnackOpen(true);
      setInfoAlert(true);
      setReportGenerated(false);
    }
  }, [reportGenerated]);

  useEffect(() => {
    if (ticketReportInfo) {
      const clonedTicketReportData = JSON.parse(
        JSON.stringify(ticketReportInfo)
      );

      if (selectedTicketStatusFilter == "ALL") {
        const issuedTickets = clonedTicketReportData.filter(
          (ticket) => ticket.transaction === "VENTE"
        );

        const refundTickets = clonedTicketReportData.filter(
          (ticket) => ticket.transaction === "REFUND"
        );

        const totalIssued = issuedTickets
          .reduce((acc, item) => {
            const taxes = Number(item?.total_taxe) || 0;
            const ht = Number(item?.ht) || 0;
            const totalAmount = taxes + ht;
            return acc + parseFloat(totalAmount);
          }, 0)
          .toFixed(2);

        const totalRefund = refundTickets
          .reduce((acc, item) => {
            const taxes = Number(item?.total_taxe) || 0;
            const ht = Number(item?.ht) || 0;
            const totalAmount = taxes + ht;
            return acc + parseFloat(totalAmount);
          }, 0)
          .toFixed(2);

        setTotalIssuedTicket(totalIssued);
        setTotalRefundTicket(totalRefund);
      }

      if (Object.values(ticketReportInfo).length > 0 && apiResponseTime > 0) {
        const newRows = clonedTicketReportData.map((value) => {
          return createData(
            value.number,
            value.transaction,
            value.traveler_name,
            value.ticket_date,
            value.ht?.toString().trim() ? value.ht : 0,
            value.total_taxe,
            value.pnr,
            value.device,
            value.formOfPayment
          );
        });
        setRow(newRows);

        if (currency === "default") {
          const res_currency = Object.values(clonedTicketReportData)?.find(
            (item) => item?.device
          )?.device;
          setRespose_currency(res_currency);
        }

        const totalFares = clonedTicketReportData
          .reduce((acc, item) => {
            const ht = Number(item?.ht) || 0;
            return acc + parseFloat(ht);
          }, 0)
          .toFixed(2);

        const totalTaxes = clonedTicketReportData
          .reduce((acc, item) => {
            const taxes = Number(item?.total_taxe) || 0;
            return acc + parseFloat(taxes);
          }, 0)
          .toFixed(2);

        const totalAmount = clonedTicketReportData
          .reduce((acc, item) => {
            const taxes = Number(item?.total_taxe) || 0;
            const ht = Number(item?.ht) || 0;
            const totalAmount = taxes + ht;
            return acc + parseFloat(totalAmount);
          }, 0)
          .toFixed(2);

        const iata = clonedTicketReportData.find(
          (item) => item?.iata_number
        )?.iata_number;

        const totalComm = clonedTicketReportData
          .reduce((acc, item) => {
            const comm = Number(item?.commission) || 0;
            return acc + parseFloat(comm);
          }, 0)
          .toFixed(2);

        setTotalFares(totalFares);
        setTotalTaxes(totalTaxes);
        setTotalAmount(totalAmount);
        setIata_number(iata);
        setTotalComm(totalComm);

        setTimeout(() => {
          if (tableRef.current) {
            tableRef.current.scrollIntoView({
              behavior: "smooth",
              block: "start",
            });
          }
        }, 100);
      } else {
        setTotalFares("0.00");
        setTotalTaxes("0.00");
        setTotalAmount("0.00");
      }
    }
  }, [ticketReportInfo, apiResponseTime]);

  useEffect(() => {
    dispatch({ type: GET_CUSTOMER_RESET });
    dispatch({ type: GET_CUSTOMER_STATIC_DATA_RESET });
    dispatch({ type: GET_TP_BATCH_REPORT_RESET });
    dispatch({ type: DOWNLOAD_INVOICE_RESET });

    return () => {
      if (invoiceFileUrlRef.current) {
        URL.revokeObjectURL(invoiceFileUrlRef.current);
      }
      dispatch({ type: DOWNLOAD_INVOICE_RESET });
      dispatch({ type: GET_TP_BATCH_REPORT_RESET });
    };
  }, [dispatch]);

  useEffect(() => {
    if (loading) {
      // setProgress(0);
      setOpenModal(true);

      const startTime = Date.now();

      const timer = setInterval(() => {
        const elapsedTime = Date.now() - startTime;

        const percentProgress =
          apiResponseTime > 0
            ? Math.min((elapsedTime / apiResponseTime) * 100, 100)
            : Math.min(elapsedTime / 100, 90);
        setProgress(percentProgress);

        if (percentProgress >= 100) {
          clearInterval(timer);
        }
      }, 100);

      return () => {
        clearInterval(timer);
        setProgress(0);
      };
    }
  }, [loading, apiResponseTime]);

  useEffect(() => {
    if (!token) {
      navigate("/");
      return;
    }

    // Only dispatch report actions after the main application login is valid.
    if (loggedInUserId) {
      dispatch(getLoggedInUser(loggedInUserId));
    }
    // if (!hasActiveReportEnabledCustomers) {
      dispatch(getActiveReportEnabledCustomers());
    // }
    dispatch(getCurrency());
  }, [
    dispatch,
    token,
    navigate,
    loggedInUserId,
      ]);

  useEffect(() => {
    if (customerById) {
      if (Object.values(customerById).length == 1) {
        setCustomer_name(customerById[0]?.customer_name?.trim());
      }
      const pcc = customerById?.pccs?.trim()?.split(" ");
      setPCCs(pcc);

      if (pcc && pcc.length == 1) {
        setSelected_pcc(pcc[0]);
      } else {
        setSelected_pcc(null);
      }
      const country = customerById?.country?.trim();
      setCustomerCountry(country);
    }
  }, [customerById]);

  useEffect(() => {
    if (currencyInfo) {
      setCurrencies((prevState) => ({ ...prevState, ...currencyInfo }));
      setCurrency("default");
    }
  }, [currencyInfo]);

  useEffect(() => {
    const filterTickets = () => {
      if (!customer_id || !Array.isArray(tpBatchReportData)) {
        setRow(null);
        setTicketReportInfo(null);
        setTotalIssuedTicket(null);
        setTotalRefundTicket(null);
        return;
      }

      let filteredTickets = JSON.parse(JSON.stringify(tpBatchReportData));

      if (
        selectedTicketStatusFilter === "ALL" &&
        selectedFormOfPaymentFilter === "ALL"
      ) {
        setTicketReportInfo(tpBatchReportData);
        const newRows =
          tpBatchReportData &&
          tpBatchReportData.map((value) => {
            return createData(
              value.number,
              value.transaction,
              value.traveler_name,
              value.ticket_date,
              value.ht?.toString().trim() ? value.ht : 0,
              value.total_taxe,
              value.pnr,
              value.device,
              value.formOfPayment
            );
          });
        setRow(newRows);
        return;
      }

      if (selectedTicketStatusFilter == "ALL") {
        const issuedTickets = tpBatchReportData.filter(
          (ticket) => ticket.transaction === "VENTE"
        );

        const refundTickets = tpBatchReportData.filter(
          (ticket) => ticket.transaction === "REFUND"
        );

        const totalIssued = issuedTickets
          .reduce((acc, item) => {
            const taxes = Number(item?.total_taxe) || 0;
            const ht = Number(item?.ht) || 0;
            const totalAmount = taxes + ht;
            return acc + parseFloat(totalAmount);
          }, 0)
          .toFixed(2);

        const totalRefund = refundTickets
          .reduce((acc, item) => {
            const taxes = Number(item?.total_taxe) || 0;
            const ht = Number(item?.ht) || 0;
            const totalAmount = taxes + ht;
            return acc + parseFloat(totalAmount);
          }, 0)
          .toFixed(2);

        setTotalIssuedTicket(totalIssued);
        setTotalRefundTicket(totalRefund);
      }

      // Filter by ticket status
      if (selectedTicketStatusFilter !== "ALL") {
        filteredTickets = filteredTickets.filter(
          (ticket) => ticket.transaction === selectedTicketStatusFilter
        );
        setTotalIssuedTicket(null);
        setTotalRefundTicket(null);
      }

      // Filter by form of payment
      if (selectedFormOfPaymentFilter !== "ALL") {
        filteredTickets = filteredTickets.filter(
          (ticket) => ticket.formOfPayment === selectedFormOfPaymentFilter
        );
      }

      const newRows =
        filteredTickets &&
        filteredTickets.map((value) => {
          return createData(
            value.number,
            value.transaction,
            value.traveler_name,
            value.ticket_date,
            value.ht?.toString().trim() ? value.ht : 0,
            value.total_taxe,
            value.pnr,
            value.device,
            value.formOfPayment
          );
        });
      setRow(newRows);
      setTicketReportInfo(filteredTickets);
    };

    filterTickets();
  }, [
    customer_id,
    selectedTicketStatusFilter,
    selectedFormOfPaymentFilter,
    tpBatchReportData,
  ]);

  const handleSnackClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackOpen(false);
    setErrorAlert(false);
    setInfoAlert(false);
  };

  const handleDateRangeChange = (ranges) => {
    if (ranges && ranges.selection) {
      const { startDate, endDate } = ranges.selection;

      if (startDate && endDate && isValid(startDate) && isValid(endDate)) {
        setDate_range({
          startDate,
          endDate,
          key: "selection",
        });
      }
    }
  };

  const getLoggedInUserDetails = () => ({
    user_id: loggedInUserId,
    email: loggedInUserEmail,
    role: decodedToken?.role || "",
    token_details: decodedToken || {},
    profile_details: loggedInUserInfo || {},
  });

  const handlePrivilegedAuthSubmit = (event) => {
    event.preventDefault();

    if (
      privilegedUsername === PRIVILEGED_REPORT_USERNAME &&
      privilegedPassword === PRIVILEGED_REPORT_PASSWORD
    ) {
      setIsPrivilegedAuthenticated(true);
      setPrivilegedAuthError("");
      setPrivilegedPassword("");
      return;
    }

    setPrivilegedAuthError("Invalid username or password.");
  };

  const handlePrivilegedAuthCancel = () => {
    navigate("/home", { replace: true });
  };

  const handleCSVDownload = (reportType) => {
    if (Object.keys(ticketReportInfo).length > 0) {
      const request_data = {
        iata_number: iata_number || "",
        ticketReportInfo: ticketReportInfo,
        total_fares: totalFares || "",
        total_taxes: totalTaxes || "",
        total_amount: totalAmount || "",
        total_comm: totalComm || "",
        currency: currency !== "default" ? currency : response_currency,
        query_date_time: query_date_time || "",
        total_issued_ticket: totalIssuedTicket || "",
        total_refund_ticket: totalRefundTicket || "",
        report_language: reportLanguage,
        logged_in_user: getLoggedInUserDetails(),
      };
      dispatch(downloadCSVFile(customer_name, request_data, reportType));
    } else {
      setErrorAlertTitle("Error!");
      setErrorAlertMessage("No data to download!");
      setSnackOpen(true);
      setErrorAlert(true);
    }
  };

  const handleExcelDownload = (fileType, reportType) => {
    if (Object.keys(ticketReportInfo).length > 0) {
      if (fileType === "xlsx") {
        setXlsxLoading(true);
      } else if (fileType === "xls") {
        setXlsLoading(true);
      }

      const request_data = {
        iata_number: iata_number || "",
        ticketReportInfo: ticketReportInfo,
        total_fares: totalFares || "",
        total_taxes: totalTaxes || "",
        total_amount: totalAmount || "",
        total_comm: totalComm || "",
        currency: currency !== "default" ? currency : response_currency,
        query_date_time: query_date_time || "",
        total_issued_ticket: totalIssuedTicket || "",
        total_refund_ticket: totalRefundTicket || "",
        report_language: reportLanguage,
        logged_in_user: getLoggedInUserDetails(),
      };

      dispatch(
        downloadExcelFile(customer_name, request_data, reportType, fileType)
      )
        .then(() => {
          // Reset loading state on success
          if (fileType === "xlsx") {
            setXlsxLoading(false);
          } else if (fileType === "xls") {
            setXlsLoading(false);
          }
        })
        .catch(() => {
          // Reset loading state on error
          if (fileType === "xlsx") {
            setXlsxLoading(false);
          } else if (fileType === "xls") {
            setXlsLoading(false);
          }
        });
    } else {
      setErrorAlertTitle("Error!");
      setErrorAlertMessage("No data to download!");
      setSnackOpen(true);
      setErrorAlert(true);
    }
  };
  const runInvoiceDownloadFlow = (
    selectedTicket,
    fileType = "pdf",
    downloadMultipleInvoice = false,
    serviceFeeDetails = {}
  ) => {
    if (!selectedTicket) {
      return;
    }

    const ticketNumber = selectedTicket.number || selectedTicket.ticket_number;
    const request_data = {
      pcc_code: selected_pcc || "",
      data: selectedTicket,
      customer_id: customer_id,
      usertype: decodedToken?.role,
      logged_in_user: getLoggedInUserDetails(),
      download_multiple_invoice: downloadMultipleInvoice,
      ...serviceFeeDetails,
    };

    setLoadingRowId(ticketNumber);

    if (fileType === "xlsx") setXlsxLoading(true);
    if (fileType === "xls") setXlsLoading(true);

    dispatch(downloadInvoiceFileUpdated(request_data, fileType)).finally(() => {
      if (fileType === "xlsx") setXlsxLoading(false);
      if (fileType === "xls") setXlsLoading(false);
    });
  };

  const handleInvoiceDownload = (fileType, row) => {
    if (!row || !row.ticket_number) {
      setErrorAlertTitle("Error!");
      setErrorAlertMessage("Invalid row data!");
      setSnackOpen(true);
      setErrorAlert(true);
      return;
    }

    if (isVoidTicket(row.ticket_status)) {
      setErrorAlertTitle("Error!");
      setErrorAlertMessage("Invoice is not available for VOID tickets.");
      setSnackOpen(true);
      setErrorAlert(true);
      return;
    }

    const reportTickets =
      (Array.isArray(tpBatchReportData) && tpBatchReportData) ||
      (Array.isArray(ticketReportInfo) && ticketReportInfo) ||
      [];

    if (reportTickets.length === 0) {
      setErrorAlertTitle("Error!");
      setErrorAlertMessage("Ticket details not available!");
      setSnackOpen(true);
      setErrorAlert(true);
      return;
    }

    const selectedTicket = reportTickets.find(
      (item) =>
        String(item.number || "").trim() === String(row.ticket_number).trim()
    );

    if (!selectedTicket) {
      setErrorAlertTitle("Error!");
      setErrorAlertMessage("Ticket details not found!");
      setSnackOpen(true);
      setErrorAlert(true);
      return;
    }

    if (isVoidTicket(getTicketStatus(selectedTicket))) {
      setErrorAlertTitle("Error!");
      setErrorAlertMessage("Invoice is not available for VOID tickets.");
      setSnackOpen(true);
      setErrorAlert(true);
      return;
    }

    const eticketCount = getEticketCount(selectedTicket);

    setPendingInvoiceRequest({
      fileType,
      pnr: selectedTicket.pnr,
      selectedTicket,
      eticketCount,
    });
    setAddServiceFee("no");
    setServiceFeeAmount("");
    setServiceFeeOption("");
    setOpenMultiTicketInvoiceDialog(true);
  };

  const handleCloseMultiTicketInvoiceDialog = () => {
    setOpenMultiTicketInvoiceDialog(false);
    setPendingInvoiceRequest(null);
    setAddServiceFee("no");
    setServiceFeeAmount("");
    setServiceFeeOption("");
  };

  const getServiceFeeRequestData = () => {
    const shouldAddServiceFee = addServiceFee === "yes";

    return {
      add_service_fee: shouldAddServiceFee,
      service_fee_amount: shouldAddServiceFee ? Number(serviceFeeAmount) : "",
      service_fee_option: shouldAddServiceFee ? serviceFeeOption : "",
    };
  };

  const validateServiceFeeSelection = () => {
    if (addServiceFee !== "yes") {
      return true;
    }

    const normalizedAmount = String(serviceFeeAmount || "").trim();
    const parsedAmount = Number(normalizedAmount);

    if (!normalizedAmount || Number.isNaN(parsedAmount) || parsedAmount <= 0) {
      setErrorAlertTitle("Error!");
      setErrorAlertMessage("Please enter a valid service fee amount.");
      setSnackOpen(true);
      setErrorAlert(true);
      return false;
    }

    if (!serviceFeeOption) {
      setErrorAlertTitle("Error!");
      setErrorAlertMessage(
        "Please select how service fees should appear in the invoice."
      );
      setSnackOpen(true);
      setErrorAlert(true);
      return false;
    }

    return true;
  };

  const handleSingleInvoiceDownload = () => {
    if (!pendingInvoiceRequest?.selectedTicket) {
      handleCloseMultiTicketInvoiceDialog();
      return;
    }

    if (!validateServiceFeeSelection()) {
      return;
    }

    const { fileType, selectedTicket } = pendingInvoiceRequest;
    const serviceFeeDetails = getServiceFeeRequestData();
    handleCloseMultiTicketInvoiceDialog();
    runInvoiceDownloadFlow(selectedTicket, fileType, false, serviceFeeDetails);
  };

  const handleAllPaxInvoiceDownload = () => {
    if (!pendingInvoiceRequest?.selectedTicket) {
      handleCloseMultiTicketInvoiceDialog();
      return;
    }

    if (!validateServiceFeeSelection()) {
      return;
    }

    const { fileType, selectedTicket } = pendingInvoiceRequest;
    const serviceFeeDetails = getServiceFeeRequestData();
    handleCloseMultiTicketInvoiceDialog();
    runInvoiceDownloadFlow(selectedTicket, fileType, true, serviceFeeDetails);
  };

  const resetInvoicePreview = () => {
    if (invoiceData?.fileUrl) {
      URL.revokeObjectURL(invoiceData.fileUrl);
    }
    dispatch({ type: DOWNLOAD_INVOICE_RESET });
  };

  const handleCloseInvoiceModel = () => {
    setOpenInvoiceModel(false);
    setLoadingRowId(null);
    resetInvoicePreview();
  };

  const clearReportData = () => {
    setProgress(0);
    setApiResponseTime(0);
    setReportGenerated(false);
    setRow(null);
    setTicketReportInfo(null);
    setTotalFares(null);
    setTotalTaxes(null);
    setTotalAmount(null);
    setTotalComm(null);
    setRespose_currency(null);
    setIata_number(null);
    setQuery_date_time(null);
    setTotalIssuedTicket(null);
    setTotalRefundTicket(null);
    setSelectTicketStatusFilter("ALL");
    setSelectFormOfPaymentFilter("ALL");
    setLoadingRowId(null);
    setOpenInvoiceModel(false);
    setOpenMultiTicketInvoiceDialog(false);
    setPendingInvoiceRequest(null);
    setAddServiceFee("no");
    setServiceFeeAmount("");
    setServiceFeeOption("");
    resetInvoicePreview();
    dispatch({ type: GET_TP_BATCH_REPORT_RESET });
  };

  const handleReportType = (event) => {
    const nextReportType = event.target.value;
    if (nextReportType === reportType) {
      return;
    }

    setPendingReportType(nextReportType);
    setOpenReportTypeReminder(true);
  };

  const handleConfirmReportTypeChange = () => {
    if (pendingReportType) {
      clearReportData();
      setReportType(pendingReportType);
    }
    setPendingReportType(null);
    setOpenReportTypeReminder(false);
  };

  const handleCancelReportTypeChange = () => {
    setPendingReportType(null);
    setOpenReportTypeReminder(false);
  };

  const submitHandler = () => {
    setProgress(0);
    setApiResponseTime(0);
    setRow(null);
    dispatch({ type: GET_TP_BATCH_REPORT_RESET });
    setReportGenerated(false);

    const { startDate, endDate } = date_range;
    if (!selected_pcc) {
      setErrorAlertTitle("Error!");
      setErrorAlertMessage(
        "Please choose the name of the customer, the relevant PCC and currency, if the customer has more than one PCC or currency."
      );
      setSnackOpen(true);
      setErrorAlert(true);
      setReportGenerated(false);
      return;
    }

    if (!startDate && !endDate) {
      setErrorAlertTitle("Error!");
      setErrorAlertMessage("Select the date range.");
      setSnackOpen(true);
      setErrorAlert(true);
      setReportGenerated(false);
      return;
    }

    const query_start = format(startDate, "ddMMMyy").toUpperCase();
    const query_end = format(endDate, "ddMMMyy").toUpperCase();
    setQuery_date_time(`${query_start}-${query_end}`);

    const formattedStartDate = format(startDate, "yyyy-MM-dd");
    const formattedEndDate = format(endDate, "yyyy-MM-dd");

    if (selected_pcc) {
      const startTime = performance.now();

      dispatch(
        getTpBatchReport(
          customer_id,
          selected_pcc,
          reportType,
          formattedStartDate,
          formattedEndDate
        )
      ).then(() => {
        const endTime = performance.now();
        const responseTime = endTime - startTime;
        setApiResponseTime(responseTime);
        setReportGenerated(true);
      });
    }
  };

  if (!isPrivilegedAuthenticated) {
    return (
      <Box sx={{ marginBottom: "5%" }}>
        <Dialog
          open
          disableEscapeKeyDown
          onClose={(event, reason) => {
            if (reason === "backdropClick" || reason === "escapeKeyDown") {
              return;
            }
          }}
          PaperProps={{
            component: "form",
            onSubmit: handlePrivilegedAuthSubmit,
          }}
        >
          <DialogTitle>Privileged Report Access</DialogTitle>
          <DialogContent sx={{ width: 360, maxWidth: "100%" }}>
            <TextField
              autoFocus
              fullWidth
              margin="dense"
              label="Username"
              value={privilegedUsername}
              onChange={(event) => setPrivilegedUsername(event.target.value)}
            />
            <TextField
              fullWidth
              margin="dense"
              label="Password"
              type="password"
              value={privilegedPassword}
              onChange={(event) => setPrivilegedPassword(event.target.value)}
            />
            {privilegedAuthError && (
              <Typography sx={{ color: "red", mt: 1 }}>
                {privilegedAuthError}
              </Typography>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={handlePrivilegedAuthCancel}>Cancel</Button>
            <Button
              type="submit"
              variant="contained"
              sx={{ backgroundColor: "#282828" }}
            >
              Unlock
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
    );
  }

  return (
    <Box sx={{ marginBottom: "5%" }}>
      <Container
        sx={{
          width: "100%",
          marginBottom: "5%",
          justifyContent: "center",
        }}
      >
        <Box sx={{ margin: 3, fontSize: 25, textAlign: "center" }}>
          Privileged New Ticket Report
          <Divider sx={{ marginTop: 2 }}></Divider>
        </Box>
        <Grid
          container
          mt={1}
          sx={{
            // backgroundColor: "#E0E0EC",
            padding: 2,
            borderRadius: 2,
            // boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.3)",
            boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
          }}
        >
          <Grid xs={4} mt={2}>
            <Typography>Customer Name</Typography>
          </Grid>
          <Grid xs={4} mt={2}>
            <Typography>PCC</Typography>
          </Grid>
          <Grid xs={4} mt={2}>
            <Typography>Currency</Typography>
          </Grid>
          <Grid
            xs={4}
            // ml={2}
            mt={1}
            sx={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Autocomplete
              size="small"
              sx={{ width: "90%" }}
              options={
                (activeReportEnabledCustomersInfo &&
                  Object.values(activeReportEnabledCustomersInfo)) ||
                []
              }
              getOptionLabel={(option) => option?.customer_name?.trim() || ""}
              renderInput={(params) => {
                return <TextField {...params} variant="outlined" />;
              }}
              onChange={(e, values) => {
                if (values) {
                  clearReportData();
                  setSelected_pcc(null);
                  dispatch(getCustomerByID(values.customer_id));
                  setCustomer_id(values.customer_id);
                  setCustomer_name(values.customer_name?.trim());
                } else {
                  clearReportData();
                  dispatch({ type: GET_CUSTOMER_RESET });
                  setPCCs([]);
                  setSelected_pcc(null);
                }
              }}
            />
          </Grid>
          <Grid
            xs={4}
            // ml={2}
            mt={1}
            sx={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Autocomplete
              size="small"
              sx={{ width: "90%" }}
              value={selected_pcc || null}
              options={(PCCs && Object.values(PCCs)) || []}
              getOptionLabel={(options) => options}
              renderInput={(params) => {
                return <TextField {...params} variant="outlined" />;
              }}
              onChange={(e, values) => {
                if (values) {
                  setSelected_pcc(values);
                } else {
                  setSelected_pcc(null);
                }
              }}
            />
          </Grid>
          <Grid
            xs={4}
            // ml={2}
            mt={1}
            sx={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Autocomplete
              size="small"
              sx={{ width: "90%" }}
              value={
                currency === "default"
                  ? { 0: "default", 1: "Default" }
                  : { 0: currency, 1: currencies[currency] }
              }
              options={(currencies && Object.entries(currencies)) || []}
              getOptionLabel={(options) => {
                if (options[0] === "default") {
                  return "Default";
                }
                return `${options[0]} - ${options[1]}`;
              }}
              renderInput={(params) => {
                return <TextField {...params} variant="outlined" />;
              }}
              onChange={(e, values) => {
                if (values) {
                  setCurrency(values[0]);
                } else {
                  setCurrency("default");
                }
              }}
            />
          </Grid>
          {customerStaticDataInfo === undefined ? (
            <Grid item xs={12} mt={3}>
              <FormControl>
                <RadioGroup
                  row
                  defaultValue={reportType}
                  value={reportType}
                  onChange={handleReportType}
                >
                  <FormControlLabel
                    value="g"
                    control={<Radio />}
                    label="General Ticket Report"
                  />
                  <FormControlLabel
                    value="c"
                    control={<Radio />}
                    label="Advanced Ticket Report"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
          ) : null}
          <Grid xs={12} mt={3}>
            Please choose your Date Range
          </Grid>
          <Grid xs={12} mt={2}>
            <DateRangePicker
              ranges={[date_range]}
              locale={enUS}
              maxDate={maxSelectableDate}
              minDate={minSelectableDate}
              onChange={handleDateRangeChange}
              editableDateInputs={true}
              rangeColors={["black"]}
            />
          </Grid>
          <Grid xs={12} mt={2} sx={{ color: "red" }}>
            Please note that privileged ticket report is allowed from last year
            till date.
          </Grid>
          <Grid xs={12} mt={3} mb={1}>
            <LoadingButton
              loading={loading}
              loadingPosition="start"
              onClick={submitHandler}
              variant="contained"
              type="submit"
              sx={{ backgroundColor: "#282828", width: "20%" }}
            >
              Generate Report
            </LoadingButton>
          </Grid>
        </Grid>
      </Container>

      {/* Ticket Report Data List */}
      {loading ? (
        <Modal open={openModal}>
          <Box sx={modalStyle}>
            <Grid container>
              <Grid xs={12}>
                <CircularProgress />
              </Grid>
              <Grid xs={12} mt={3} md={0}>
                <Typography>
                  Just a moment, we're preparing everything for you.
                </Typography>
              </Grid>
            </Grid>
          </Box>
        </Modal>
      ) : row ? (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
          ref={tableRef}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              // textAlign: "center",
              // width: "70%",
              width: isSmallScreen ? "95%" : isMediumScreen ? "70%" : "70%",
            }}
          >
            <Box
              sx={{
                display: "flex",
                width: "50%",
                justifyContent: "left",
              }}
            >
              <Autocomplete
                size="small"
                sx={{
                  width: isSmallScreen ? "40%" : isMediumScreen ? "30%" : "25%",
                }}
                options={ticketStatusFilter || []}
                value={selectedTicketStatusFilter || null}
                getOptionLabel={(options) => options}
                renderInput={(params) => {
                  return (
                    <TextField
                      {...params}
                      variant="outlined"
                      label="Ticket Status"
                    />
                  );
                }}
                onChange={(e, values) => {
                  if (values) {
                    setSelectTicketStatusFilter(values);
                  }
                }}
              />
              <Autocomplete
                size="small"
                sx={{
                  width: isSmallScreen ? "50%" : isMediumScreen ? "40%" : "35%",
                  marginLeft: 3,
                }}
                value={selectedFormOfPaymentFilter || null}
                options={formOfPaymentFilter || []}
                getOptionLabel={(options) => formatFormOfPaymentLabel(options)}
                renderInput={(params) => {
                  return (
                    <TextField
                      {...params}
                      variant="outlined"
                      label="Form Of Payment"
                    />
                  );
                }}
                onChange={(e, values) => {
                  if (values) {
                    if (values != "ALL") {
                      let formattedValue;
                      if (values === "MiscFormOfPayment") {
                        formattedValue = values;
                      } else if (values === "Credit") {
                        formattedValue = values;
                      } else {
                        formattedValue =
                          values.charAt(0).toUpperCase() +
                          values.slice(1).toLowerCase();
                      }
                      setSelectFormOfPaymentFilter(formattedValue);
                    } else {
                      setSelectFormOfPaymentFilter(values);
                    }
                  }
                }}
              />
            </Box>
            <Box
              sx={{
                display: "flex",
                width: "50%",
                justifyContent: "right",
              }}
            >
              <LoadingButton
                loading={xlsxLoading}
                loadingIndicator="Downloading..."
                onClick={() => handleExcelDownload("xlsx", reportType)}
                variant="contained"
                type="submit"
                sx={{
                  backgroundColor: "#282828",
                  width: isSmallScreen ? "40%" : isMediumScreen ? "30%" : "25%",
                }}
              >
                Download .xlsx
              </LoadingButton>
              <LoadingButton
                loading={xlsLoading}
                loadingIndicator="Downloading..."
                onClick={() => handleExcelDownload("xls", reportType)}
                variant="contained"
                type="submit"
                sx={{
                  backgroundColor: "#282828",
                  width: isSmallScreen ? "40%" : isMediumScreen ? "30%" : "25%",
                  marginLeft: 3,
                }}
              >
                Download .xls
              </LoadingButton>
              <LoadingButton
                loading={downloadCSVLoading}
                loadingIndicator="Downloading..."
                onClick={() => handleCSVDownload(reportType)}
                variant="contained"
                type="submit"
                sx={{
                  backgroundColor: "#282828",
                  width: isSmallScreen ? "40%" : isMediumScreen ? "30%" : "25%",
                  marginLeft: 3,
                }}
              >
                Download CSV
              </LoadingButton>
              <HtmlTooltip
                title={
                  <Fragment>
                    <Typography sx={{ fontWeight: "bold" }}>
                      This setting only takes effect after downloading the Excel
                      file.
                    </Typography>
                    <br />
                    <Typography sx={{ fontWeight: "bold" }}>
                      Changing regional settings in Web Excel
                    </Typography>
                    <Typography>- Select File</Typography>
                    <Typography>- Select Options</Typography>
                    <Typography>- Select Regional Settings</Typography>
                    <Typography>
                      - Select a region from the drop-down list
                    </Typography>
                    <Typography>- Select Change</Typography>
                    <br />
                    <Typography sx={{ fontWeight: "bold" }}>
                      Changing regional settings in Windows
                    </Typography>
                    <Typography>- Select the Start button</Typography>
                    <Typography>- Select Settings</Typography>
                    <Typography>- Select Time & language</Typography>
                    <Typography>- Select Region</Typography>
                    <Typography>
                      - Select Change date, time, or number formats
                    </Typography>
                    <br />
                    <Typography sx={{ fontWeight: "bold" }}>
                      If your date format is already set to DD/MM/YYYY, you can
                      ignore these instructions.
                    </Typography>
                  </Fragment>
                }
                arrow
              >
                <LiveHelpIcon
                  fontSize="large"
                  sx={{ color: "red", marginLeft: 2 }}
                />
              </HtmlTooltip>
            </Box>
          </Box>
          <Box
            sx={{
              marginTop: 3,
              width: isSmallScreen ? "95%" : isMediumScreen ? "70%" : "70%",
            }}
          >
            <TableContainer
              component={Paper}
              sx={{
                borderRadius: 3,
              }}
            >
              <Table>
                <TableHead>
                  <TableRow>
                    <StyledTableCell>Currency</StyledTableCell>
                    <StyledTableCell>Total Fares</StyledTableCell>
                    <StyledTableCell>Total Taxes</StyledTableCell>
                    <StyledTableCell>Total Amount</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <StyledTableCell>
                    {currency !== "default" ? currency : response_currency}
                  </StyledTableCell>
                  <StyledTableCell>{totalFares}</StyledTableCell>
                  <StyledTableCell>{totalTaxes}</StyledTableCell>
                  <StyledTableCell>{totalAmount}</StyledTableCell>
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
          <Box
            sx={{
              width: isSmallScreen ? "95%" : isMediumScreen ? "70%" : "70%",
              marginTop: 3,
            }}
          >
            <TableContainer component={Paper} sx={{ borderRadius: 3 }}>
              <Table>
                <TableHead>
                  <TableRow>
                    <StyledTableCell>Date</StyledTableCell>
                    <StyledTableCell>PNR</StyledTableCell>
                    <StyledTableCell>Name</StyledTableCell>
                    <StyledTableCell>Ticket Number</StyledTableCell>
                    <StyledTableCell>Fare</StyledTableCell>
                    <StyledTableCell>Taxes</StyledTableCell>
                    <StyledTableCell>Ticket Status</StyledTableCell>
                    <StyledTableCell>FOP</StyledTableCell>
                    <StyledTableCell>Currency</StyledTableCell>
                    <StyledTableCell>Invoice</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {row?.length > 0 ? (
                    row.map((row) => (
                      <StyledTableRow>
                        <StyledTableCell component="th" scope="row">
                          {row.date}
                        </StyledTableCell>
                        <StyledTableCell component="th" scope="row">
                          {row.pnr}
                        </StyledTableCell>
                        <StyledTableCell component="th" scope="row">
                          {row.name.trim()}
                        </StyledTableCell>
                        <StyledTableCell component="th" scope="row">
                          {row.ticket_number}
                        </StyledTableCell>
                        <StyledTableCell component="th" scope="row">
                          {row.fare||0}
                        </StyledTableCell>
                        <StyledTableCell component="th" scope="row">
                          {row.taxes}
                        </StyledTableCell>
                        <StyledTableCell component="th" scope="row">
                          {row.ticket_status}
                        </StyledTableCell>
                        <StyledTableCell component="th" scope="row">
                          {formatFormOfPaymentLabel(row.fop)}
                        </StyledTableCell>
                        <StyledTableCell component="th" scope="row">
                          {row.currency}
                        </StyledTableCell>
                        <StyledTableCell component="th" scope="row">
                          <LoadingButton
                            loading={loadingRowId === row.ticket_number}
                            loadingIndicator="Preparing..."
                            disabled={isVoidTicket(row.ticket_status)}
                            onClick={() => handleInvoiceDownload("pdf", row)}
                            variant="contained"
                            sx={{
                              backgroundColor: "#282828",
                              width: "80%",
                              marginLeft: 3,
                            }}
                          >
                            View Invoice
                          </LoadingButton>
                        </StyledTableCell>

                      </StyledTableRow>
                    ))
                  ) : (
                    <StyledTableRow
                      style={{
                        wordWrap: "break-word",
                        maxWidth: "100%",
                      }}
                    >
                      <StyledTableCell
                        component="th"
                        colSpan={9}
                        scope="row"
                        style={{
                          textAlign: "center",
                          wordWrap: "break-word",
                          maxWidth: "100%",
                          fontSize: 15,
                        }}
                      >
                        No data found
                      </StyledTableCell>
                    </StyledTableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </Box>
      ) : null}

      {errorAlert && (
        <Snackbar
          open={snackOpen}
          autoHideDuration={5000}
          onClose={handleSnackClose}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          sx={{ width: "20%" }}
        >
          <Alert
            onClose={handleSnackClose}
            severity="error"
            sx={{ width: "100%" }}
          >
            <AlertTitle>{errorAlertTitle}</AlertTitle>
            {errorAlertMessage}
          </Alert>
        </Snackbar>
      )}
      {infoAlert && (
        <Snackbar
          open={snackOpen}
          autoHideDuration={5000}
          onClose={handleSnackClose}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          sx={{ width: "20%" }}
        >
          <Alert
            onClose={handleSnackClose}
            severity="info"
            sx={{ width: "100%" }}
          >
            {/* <AlertTitle>{errorAlertTitle}</AlertTitle> */}
            {infoAlertMessage}
          </Alert>
        </Snackbar>
      )}
      <Dialog open={openInvoiceModel} onClose={handleCloseInvoiceModel} maxWidth="lg" fullWidth>
        <DialogTitle>
          Invoice Preview
          <IconButton
            onClick={handleCloseInvoiceModel}
            sx={{ position: "absolute", right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers sx={{ height: "75vh" }}>
          {invoiceData && !invoiceError && (
            <object
              data={invoiceData.fileUrl}
              type="application/pdf"
              width="100%"
              height="100%"
            />

          )}
        </DialogContent>

        <DialogActions>
          <Button
            variant="contained"
            onClick={() => {
              const link = document.createElement("a");
              link.href = invoiceData.fileUrl;
              link.download = invoiceData.fileName;
              link.click();
            }}
          >
            Download Invoice
          </Button>

          <Button variant="outlined" onClick={handleCloseInvoiceModel}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openMultiTicketInvoiceDialog}
        onClose={handleCloseMultiTicketInvoiceDialog}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Invoice Options</DialogTitle>
        <DialogContent dividers>
          {pendingInvoiceRequest?.eticketCount > 1 ? (
            <Typography>
              PNR {pendingInvoiceRequest?.pnr || "-"} has multiple e-tickets
              {pendingInvoiceRequest?.eticketCount
                ? ` (${pendingInvoiceRequest.eticketCount} found)`
                : ""}
              . Do you want to download a single invoice or an invoice for all
              pax?
            </Typography>
          ) : (
            <Typography>
              Configure the invoice options below and continue to preview the
              invoice.
            </Typography>
          )}

          <FormControl component="fieldset" sx={{ mt: 3, width: "100%" }}>
            <FormLabel>Do you want to add service fees?</FormLabel>
            <RadioGroup
              row
              value={addServiceFee}
              onChange={(event) => {
                const value = event.target.value;
                setAddServiceFee(value);
                if (value !== "yes") {
                  setServiceFeeAmount("");
                  setServiceFeeOption("");
                }
              }}
            >
              <FormControlLabel value="yes" control={<Radio />} label="Yes" />
              <FormControlLabel value="no" control={<Radio />} label="No" />
            </RadioGroup>
          </FormControl>

          {addServiceFee === "yes" && (
            <Box sx={{ mt: 2 }}>
              <TextField
                label="Service Fee Amount"
                type="number"
                size="small"
                fullWidth
                value={serviceFeeAmount}
                onChange={(event) => setServiceFeeAmount(event.target.value)}
                inputProps={{ min: 0, step: "0.01" }}
              />

              <FormControl component="fieldset" sx={{ mt: 2, width: "100%" }}>
                <FormLabel>How should service fees be handled?</FormLabel>
                <RadioGroup
                  value={serviceFeeOption}
                  onChange={(event) => setServiceFeeOption(event.target.value)}
                >
                  <FormControlLabel
                    value="included_in_final_amount_invisible"
                    control={<Radio />}
                    label="Include service fees in the final invoice amount, and do not keep them separate (invisible)"
                  />
                  <FormControlLabel
                    value="included_in_final_amount_visible"
                    control={<Radio />}
                    label="Include service fees in the final invoice amount, and keep them separate (visible)"
                  />
                </RadioGroup>
              </FormControl>
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleCloseMultiTicketInvoiceDialog}
            variant="outlined"
          >
            Cancel
          </Button>
          <Button
            onClick={handleSingleInvoiceDownload}
            variant={
              pendingInvoiceRequest?.eticketCount > 1
                ? "outlined"
                : "contained"
            }
          >
            {pendingInvoiceRequest?.eticketCount > 1
              ? "Single Invoice"
              : "View Invoice"}
          </Button>
          {pendingInvoiceRequest?.eticketCount > 1 && (
            <Button onClick={handleAllPaxInvoiceDownload} variant="contained">
              Invoice For All Pax
            </Button>
          )}
        </DialogActions>
      </Dialog>
      <Dialog
        open={openReportTypeReminder}
        onClose={handleCancelReportTypeChange}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Alert</DialogTitle>
        <DialogContent dividers>
          <Typography>
             {/* Please download the {reportType === "c" ? "Advanced" : "General"} Ticket Report before switching to {pendingReportType === "c" ? "Advanced" : "General"} Ticket Report. This data will be cleared. */}
          
           You are about to switch report options. Your existing report data will be cleared if you have not downloaded the files.
          </Typography>
          <Typography sx={{ mt: 2 }}>
            If you wish to continue, click OK. Otherwise, click Cancel to go back
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancelReportTypeChange} variant="outlined">
            Cancel
          </Button>
          <Button onClick={handleConfirmReportTypeChange} variant="contained">
            OK
          </Button>
        </DialogActions>
      </Dialog>

    </Box>
  );
}
